<template>
  <input
    :value="value"
    class="numeric-input"
    type="number"
    @input="$emit('input', Number($event.target.value))"
  >
</template>

<script>
export default {
  name: 'InputNumericBox',
  props: {
    value: {
      type: [Number, String],
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
    .numeric-input {
      width: 48px;
      height: 52px;
      border: 1px solid $bionic-grey-600;
      border-radius: 6px;
      background-color: $white;
      text-align: center;
      color: $bionic-navy;
      font-size: 16px;
      line-height: 20px;
      transition: .2s linear border;

      &:focus {
        outline-width: 0;
        border: 1px solid #1370FF;
      }
    }
</style>
